import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom-v6'
import { Network, SlidersHorizontal, Users } from 'lucide-react'
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@clouway/ui'

// i18n keys (common namespace) rather than literals — the app is bg-primary.
const sections = [
  {
    labelKey: 'drawer.sections.operations',
    items: [
      {
        titleKey: 'drawer.items.home',
        url: '/',
        icon: Users,
        isActive: (pathname: string) => pathname === '/' || pathname.startsWith('/customers'),
      },
    ],
  },
  {
    labelKey: 'drawer.sections.configuration',
    items: [
      {
        titleKey: 'drawer.items.configTemplatesTitle',
        url: '/config-templates',
        icon: SlidersHorizontal,
        isActive: (pathname: string) => pathname.startsWith('/config-templates'),
      },
      {
        titleKey: 'drawer.items.networks',
        url: '/networks',
        icon: Network,
        isActive: (pathname: string) => pathname.startsWith('/networks'),
      },
    ],
  },
] as const

function AppSidebar() {
  const { t } = useTranslation('common')
  const { pathname } = useLocation()

  return (
    <Sidebar>
      <SidebarHeader>
        <span className="px-2 py-1.5 text-sm font-semibold">Fleerp Partner Backoffice</span>
      </SidebarHeader>
      <SidebarContent>
        {sections.map((section) => (
          <SidebarGroup key={section.labelKey}>
            <SidebarGroupLabel>{t(section.labelKey)}</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {section.items.map((item) => (
                  <SidebarMenuItem key={item.url}>
                    <SidebarMenuButton asChild isActive={item.isActive(pathname)}>
                      <Link to={item.url}>
                        <item.icon />
                        <span>{t(item.titleKey)}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
    </Sidebar>
  )
}

export default AppSidebar
